import React from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { connect } from "formik";

const Label = styled.div`
  font-size:17px !important;
  font-weight:bold;
  color: rgb(51,51,51)
  min-width:200px;
`;
const LabelGrid = styled(Grid)`
  && {
    width: 200px;
  }
`;
const FormGrid = styled(Grid)`
  min-height:40px;
  margin-left: 30px !important;
  border-bottom: ${props => (props.hasBorder ? "1px solid gainsboro" : "")}
`;
const LateralField = ({ label, children, hasBorder, formik, shouldHideForQuote, shouldIndent, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  return (
    <Grid container item alignItems="center" justify="flex-start" style={{ paddingLeft: shouldIndent ? "55px" : "" }}>
      <LabelGrid container item alignItems="flex-start"><Label>{label}</Label></LabelGrid>
      <FormGrid hasBorder={hasBorder} container item xs={7} alignItems="center">{children}</FormGrid>
    </Grid>
  );
};

export default connect(LateralField);
